/**
 * Portal Manta · OAECross
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { V } from '../../globals.js';

function OAECross({label, vigamento, fundacao, w=320}){
  return (<div style={{textAlign:'center'}}>
    <div style={{fontSize:11,fontWeight:700,color:V.br,marginBottom:6}}>{label}</div>
    <svg width={w} height={220} viewBox={`0 0 ${w} 220`}>
      {/* Tabuleiro */}
      <rect x={20} y={50} width={w-40} height={12} fill="#888" stroke={V.g7} strokeWidth="0.5"/>
      <text x={w/2} y={59} textAnchor="middle" fontSize="9" fill="#fff" fontWeight="600">Tabuleiro · 21,5 m · h=22 cm</text>
      {/* Vigas (4 vigas tipo I) */}
      {[0,1,2,3].map(i=>{
        const x = 35 + i*((w-70)/3);
        return (<g key={i}>
          <rect x={x-4} y={62} width={8} height={3} fill={V.g7}/>
          <rect x={x-1.5} y={65} width={3} height={26} fill={V.g7}/>
          <rect x={x-4} y={91} width={8} height={3} fill={V.g7}/>
        </g>);
      })}
      <text x={w/2} y={110} textAnchor="middle" fontSize="9" fill={V.g5}>4× Viga tipo I · h=1,60 m · vão 30 m</text>
      {/* Pilar */}
      <rect x={w/2-10} y={115} width={20} height={50} fill="#A8A8A8" stroke={V.g7} strokeWidth="0.5"/>
      <text x={w/2+18} y={143} fontSize="9" fill={V.g5}>Pilar concreto fck 35</text>
      {/* Bloco fundação */}
      <rect x={w/2-30} y={165} width={60} height={10} fill="#7A6450"/>
      <text x={w/2} y={172} textAnchor="middle" fontSize="8" fill="#fff">Bloco fundação</text>
      {/* Estacas */}
      {[-1,0,1].map(i=>(<g key={i}>
        <rect x={w/2-3+i*15} y={175} width={6} height={35} fill="#6B5840"/>
      </g>))}
      <text x={w/2} y={205} textAnchor="middle" fontSize="9" fill={V.g5}>{fundacao}</text>
      {/* cota largura */}
      <line x1={20} y1={42} x2={w-20} y2={42} stroke={V.g4} strokeWidth="0.6" markerStart="url(#arr)" markerEnd="url(#arr)"/>
      <text x={w/2} y={37} textAnchor="middle" fontSize="9" fill={V.g5}>21,5 m</text>
    </svg>
    <div style={{fontSize:10,color:V.g4,marginTop:2,fontStyle:'italic'}}>{vigamento}</div>
  </div>);
}

export { OAECross };
export default OAECross;
